function initializeCalcAccordion() {

  const url = new URL(window.location.href)
  const accordions = $('#widget-accordions')
  const calculatorPrefix = '#calc-';

  if (accordions.length > 0) {

    if (url.searchParams.has('c')) {
      let parameter = url.searchParams.get('c')
      let calculatorId = calculatorPrefix + parameter;
      let calcAccordion = $(calculatorId)
      if (calcAccordion.length > 0) {
        calcAccordion.trigger('click')

        $('html, body').animate({
          scrollTop: calcAccordion.offset().top
        }, 500, function () {
          $('html, body').scrollTop(calcAccordion.offset().top) // Set offset on complete to account for other collapses changing the offset
        });

      }
    }

  }
}

document.addEventListener('DOMContentLoaded', (event) => {
  initializeCalcAccordion()
})
